import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { ReauthorizationFinanceRequestModel, ReauthorizationFinanceResponseModel } from "@/features/accounts/finance/services/reauthorization-model";

export class ReauthorizationFinanceApi {
  /**
   * 金融機関サイト認可画面要求(再認可)API
   */
  public reauthorizeFinance = async (
    param: ReauthorizationFinanceRequestModel
  ): Promise<ReauthorizationFinanceResponseModel> => {
    const path = `/api/financeaccounts/authorization`;
    const res = await ApiClient.instance.get<ReauthorizationFinanceResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
